<template>
  <vx-card id="invoice-container">
    <template>
      <div>
        <vs-row vs-justify="flex-end">
          <div class="vx-row mr-2 flex-1">
            <div class="vx-col mb-3">
              <vs-row class="font-semibold">{{ $t('entity.created_at') }}:</vs-row>
              <vs-row class="mt-3">{{ invoice.created_at | datetime }}</vs-row>
            </div>
            <div class="vx-col mb-3">
              <vs-row class="font-semibold">{{ $t('entity.state') }}:</vs-row>
              <vs-row class="mt-3"><cell-badges :data="invoice.state" local="invoices.states." /> </vs-row>
            </div>
          </div>
        </vs-row>

        <vs-table hoverFlat :data="invoice.items" class="mb-3">
          <template slot="thead">
            <vs-th>{{ $t('request_forms.service_name') }}</vs-th>
            <vs-th>{{ $t('request_forms.price') | thousands }}</vs-th>
            <vs-th>{{ $t('request_forms.number_of_service') }}</vs-th>
            <vs-th>{{ $t('request_forms.total_price') }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody v-if="data.length">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  {{ $t('reservation.reserve') }}
                </vs-td>
                <vs-td>{{ tr.price | thousands }}</vs-td>
                <vs-td>
                  {{ tr.count | persian_digits }}
                  {{ tr.service !== 'transport' ? $t(`units.${tr.unit}`) : '' }}
                </vs-td>
                <vs-td>
                  {{ (tr.price * tr.count) | thousands }}
                </vs-td>
              </vs-tr>
            </tbody>
            <tfoot>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ $t('invoices.wage') }}:</vs-td>
                <vs-td>{{ invoice.wage | thousands }}</vs-td>
              </vs-tr>
              <vs-tr class="font-semibold">
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ $t('invoices.total') }}:</vs-td>
                <vs-td>{{ invoice.totalPrice | toman }}</vs-td>
              </vs-tr>
            </tfoot>
          </template>
        </vs-table>
      </div>
    </template>
    <div slot="footer">
      <vs-row vs-justify="flex-end" class="print-hidden">
        <vs-button
          icon-pack="feather"
          icon="icon-x"
          color="danger"
          @click="openCancelConfirm()"
          v-if="invoice.state === 'pending' && ['pending', 'accepted'].includes(request.status)"
        >
          {{ $t('invoices.cancel') }}
        </vs-button>
        <vs-button
          color="success"
          id="button-pay-loading"
          class="vs-con-loading__container"
          :disabled="payBtnDisable"
          @click="payInvoice"
          v-if="invoice.state === 'unpaid' && invoice.paypingPaymentId"
        >
          {{ $t('invoices.online_pay') }}
        </vs-button>
        <edit-case-manager-price
          v-if="request.caseManagerUserID === $store.state.AppActiveUser.id"
          :invoice="invoice"
          class="ml-2"
        />
      </vs-row>
    </div>
  </vx-card>
</template>

<script>
import modulePayping from '@/store/payping/modulePayping'
import CellBadges from '@/views/components/common/table-cells/CellBadges'
import EditCaseManagerPrice from '@/views/pages/case-manager/invoice/EditCaseManagerPrice'

export default {
  name: 'InvoiceView',
  components: { EditCaseManagerPrice, CellBadges },
  data() {
    return {
      invoice: {},
      request: {},
      payBtnDisable: false
    }
  },
  methods: {
    payInvoice() {
      this.payBtnDisable = true

      this.$vs.loading({
        background: 'success',
        container: '#button-pay-loading',
        color: '#fff',
        scale: 0.45
      })

      this.$store
        .dispatch('payping/fetchPaymentIpg', this.invoice.paypingPaymentId)
        .then(response => {
          window.location = response.data
        })
        .finally(() => {
          this.payBtnDisable = false
          this.$vs.loading.close('#button-pay-loading > .con-vs-loading')
        })
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    this.$store
      .dispatch('invoice/fetchInvoice', this.$route.params.id)
      .then(res => {
        this.invoice = res.data
      })
      .finally(() => this.$vs.loading.close())
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
